<div class="frac-fctv-contract-addedit">
  <form [formGroup]="contractForm" (ngSubmit)="saveAndUseContract()">
    <div class="details col">
      <mat-form-field class="form-field">
        <input matInput placeholder="Contract Name" formControlName="name" autocomplete="off" />
      </mat-form-field>
      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Hourly Detention Rate ($)"
          formControlName="hourlyDetentionRate"
          autocomplete="off"
          saCurrencyInput
        />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Max Detention per Load ($)"
          formControlName="maxDetentionPerLoad"
          autocomplete="off"
          saCurrencyInput
        />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Pickup Free Time (minutes)"
          formControlName="pickupFreeTime"
          autocomplete="off"
          type="number"
        />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Dropoff Free Time (minutes)"
          formControlName="dropoffFreeTime"
          autocomplete="off"
          type="number"
        />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Deadhead Free Mileage"
          formControlName="deadheadFreeMileage"
          autocomplete="off"
          type="number"
        />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Deadhead Cost per Mile ($)"
          formControlName="deadheadCostPerMile"
          autocomplete="off"
          saCurrencyInput
        />
      </mat-form-field>

      <mat-form-field class="form-field" *saFeatureFlag="'require_frac_trailer_types'">
        <mat-select formControlName="trailerTypeId" placeholder="Trailer Type">
          <mat-option *ngIf="!requireTrailerType" [value]="null">None</mat-option>
          <mat-option *ngFor="let type of trailerTypes$ | async; trackBy: trackByTrailerType" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="contractForm.controls['trailerTypeId']?.hasError('required')">
          Trailer type is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="distribution col">
      <h4>Cost Per Load</h4>
      <div class="distributions">
        <ng-container
          *ngFor="let costPerLoad of costsPerLoad.controls; let i = index; trackBy: trackByIndex"
          formArrayName="costsPerLoad"
        >
          <div class="costs-per-load" [formGroupName]="i" [@fadeInAndOut]="'in'">
            <mat-form-field class="costs-per-load-input">
              <input
                matInput
                type="number"
                placeholder="Min Miles"
                formControlName="minimumMileage"
                autocomplete="off"
              />
            </mat-form-field>
            <mat-form-field class="costs-per-load-input">
              <input
                matInput
                type="number"
                placeholder="Max Miles"
                formControlName="maximumMileage"
                autocomplete="off"
              />
            </mat-form-field>
            <mat-form-field class="costs-per-load-input">
              <input matInput placeholder="Cost ($)" formControlName="cost" saCurrencyInput />
            </mat-form-field>
            <button
              class="remove-button"
              mat-mini-fab
              type="button"
              color="warn"
              *ngIf="canEditContract"
              (click)="removeCostPerLoadLine(i)"
              [disabled]="costsPerLoad.length < 2"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </ng-container>
        <button
          mat-mini-fab
          type="button"
          color="primary"
          (click)="addCostPerLoadLine()"
          class="add-button"
          *ngIf="canEditContract"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <div></div>
      <button
        class="submit"
        mat-raised-button
        color="primary"
        type="submit"
        saAutomatedSelector="fctv_contract_addedit__submit"
      >
        {{
          contractFormValue.id
            ? this.canEditContract
              ? 'Edit and Use Vendor Contract'
              : 'Use Vendor Contract'
            : 'Save New Contract'
        }}
      </button>
    </div>
  </form>
</div>
